<template>
  <Dropdown
    maxHeight="0"
    ref="dd"
    :position="dd_position || 'top-middle'"
    :anchorID="anchorID"
    @toggled-dropdown="toggle"
    :offset="dd_position == 'top-right' ? 10 : 0"
  >
    <template slot="toggle">
      <div class="event-color-toggle">
        <span :style="{ 'background-color': value }"></span>
      </div>
    </template>
    <template slot="content">
      <ColorPicker
        v-model="value"
        @input="
          (c) => {
            color = c;
            $refs.dd.close();
          }
        "
      />
      <div>
        <TextField v-model="color" class="font-h6 block" placeholder="HEX COLOR" />
      </div>
    </template>
  </Dropdown>
</template>

<script>
export default {
  name: "SelectColor",
  components: {},
  props: {
    value: String,
    anchorID: {
      default: "",
      type: String,
    },
    dd_position: {
      default: "",
      type: String,
    },
  },
  data: function () {
    return {
      color: "",
    };
  },
  async mounted() {
    this.color = this.value;
  },
  methods: {
    toggle(open) {
      if (!open) {
        if (this.color.toUpperCase().match(/^#[0-9A-F]{6}$/)) {
          this.color = this.color.toUpperCase();
          this.$emit("input", this.color.toUpperCase());
        } else {
          this.color = this.value;
        }
      }
    },
  },
};
</script>
